import { useParams, useNavigate } from 'react-router-dom';
import { Container } from '../layout/AppLayout.js'
import { useEffect, useContext, useState } from 'react';
import { isAllowed } from '../shared/FeatureChecker.js';
import { useQuery } from 'react-query';
import Header from "../shared/Header.js"
import { CurrentUserContext } from '../../App.js';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import { formatDate, useFromQueryString, toQueryString } from '../../utils.js'
import Spinner from '../shared/Spinner.js';
import Col from 'react-bootstrap/Col';
import TableList from '../shared/TableList.js';
import Pagination from '../shared/Pagination.js';
import useFeatureChecker, { AllowedFeature } from '../shared/FeatureChecker.js';

function DetailsCard({ implementation }) {
  if(implementation==null){ return null}
    return (
      <div>
        <div className="form-group">
          <label className="form-label font-weight-bold">Nombre</label>
          <p>{implementation.name?implementation.name:"--"}</p>
        </div>

        <div className="form-group">
          <label className="form-label font-weight-bold">Plataforma</label>
          <p>{implementation.platform?implementation.platform:"--"}</p>
        </div>
        <div className="form-group">
          <label className="form-label font-weight-bold">Fecha de creación</label>
          <p>{formatDate(implementation.created_at)}</p>
        </div>
        {
          implementation.platform =='AWS' && implementation.extra.awsRegion?(
             <div className="form-group">
              <label className="form-label font-weight-bold">AWS región</label>
              <p>{implementation.extra.awsRegion}</p>
            </div>
          ):null
        }
        {
          implementation.platform =='AWS' && implementation.extra.awsAccessKeyId?(
             <div className="form-group">
              <label className="form-label font-weight-bold">Access key ID</label>
              <p>{implementation.extra.awsAccessKeyId}</p>
            </div>
          ):null
        }
        {
          implementation.platform =='AWS' && implementation.extra.awsArnRol?(
             <div className="form-group">
              <label className="form-label font-weight-bold">Arn del rol</label>
              <p>{implementation.extra.awsArnRol}</p>
            </div>
          ):null
        }
      </div>
    )
}

function HistoryDetailCard({ history }) {
  if(history==null){ 
    return (
      <div>
        <span>No hay historial disponible</span>
      </div>
    )}
    return (
        <TableList>
          <TableList.Header>
            <TableList.HeaderItem value="Evento" />
            <TableList.HeaderItem value="Tipo" />
            <TableList.HeaderItem value="Plataforma" />
            <TableList.HeaderItem value="Fecha" />
          </TableList.Header>
          <TableList.Body>
            {
               history.map(item => (
                  <TableList.Row key={item.uuid}>
                    <TableList.Column>
                      {item.state}
                    </TableList.Column>
                    <TableList.Column>
                      {item.type}
                    </TableList.Column>
                    <TableList.Column>
                      {item.platform}
                    </TableList.Column>
                    <TableList.Column>
                      {formatDate(item.created_at,"dd/MM/yyyy HH:mm:ss")}
                    </TableList.Column>
                  </TableList.Row>
               ))
            }
          </TableList.Body>
        </TableList>
    )
}

export default function DigitalsImplementationDetailsPage() {
  const CheckFeatures = useFeatureChecker()
  const params = useParams()
  const currentUser = useContext(CurrentUserContext)
  const navigate = useNavigate()
  const queryString = useFromQueryString()
  const query = useQuery(`logsdigitals/implementation/${params.id}`)

  const [ currentFilters, setCurrentFilters ] = useState({
      page: parseInt(queryString.page) || 1,
      limit: parseInt(queryString.limit) || 5,
    })

  const query_logs = useQuery(`digitalhistory/${params.id}?${toQueryString(currentFilters)}`, {
      keepPreviousData: true,
    })
  useEffect(() => {
    navigate('?' + toQueryString(currentFilters), { replace: true })
  }, [currentFilters])

  useEffect(() => {
    if(currentUser){
      const allowed= isAllowed({user: currentUser, feature: "DETAIL_IMPLEMENTATION"})
      if (!allowed){
        navigate('/error?error=403')
      }
    }

  },[currentUser])

  return (
    <Container>
      <div className="row">
          <Header title="Detalle de logs digital" items={[
          { label: `Listado logs digital`, to: "/digitals/implementation" },
          { label: `Detalle del la implementación` },
          ]}>
          </Header>
      </div>
      <Row className="mb-2 pb-4">
        <Col className="col-6 ">
          <Card className="shadow-sm mb-3">
            <Card.Header className="card-hearder">
              <span>Detalle del la implementación</span>
            </Card.Header>
            <Card.Body>   
              {
                query.isLoading ?
                  <div className="text-center my-4">
                    <Spinner />
                  </div>
                :
                <DetailsCard implementation={query.data && query.data.result && query.data.result[0]} />
              }            
            </Card.Body>
          </Card>
        </Col>
        <CheckFeatures feature="LIST_IMPLEMENTATION_LOGS">
          <AllowedFeature>
            <Col className="col-6">
              <Card className="shadow-sm mb-3">
                <Card.Header className="card-hearder">
                    <span>Historial de la implementación</span>
                </Card.Header>
                <Card.Body>   
                  {
                    query_logs.isLoading ?
                      <div className="text-center my-4">
                        <Spinner />
                      </div>
                    :
                    <HistoryDetailCard history={query_logs.data && query_logs.data.result} />
                  }            
                </Card.Body>
                <Row className="mt-2 ml-2">
                  <Pagination
                    pagination={query_logs.data && query_logs.data.pagination}
                    isLoading={query_logs.isFetching}
                    onChange={page => setCurrentFilters(prev => ({ ...prev, page }))}
                  />
                </Row>
              </Card>
            </Col>
          </AllowedFeature>
        </CheckFeatures>
      </Row>
    </Container>
  )
}
